<template>
	<div id="compliance-main" :class="{ 'has-selection': hasSelection }">
		<div id="side-bar">
			<side-bar/>
		</div>
		<div id="compliance-view">
			<span id="back-to-items" v-if="hasSelection" @click="backToItems">&larr; Menu</span>
			<router-view/>
		</div>
		<ViewComplianceFileModal v-if="viewComplianceFilesModal"/>
		<ViewVendorComplianceDetailsModal v-if="viewVendorComplianceDetailsModal"/>
		<DeleteVendorComplianceDetailsModal v-if="showDeleteVendorComplianceDetailConfirm"/>
		<DocHubInstructionsModal v-if="viewDocHubInstructionModal"/>
		<CompleteFormModal v-if="viewCompleteOnlineFormModal"/>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import SideBar from './SideBar.vue'
import ViewComplianceFileModal from '@/components/Home/Modals/ViewComplianceFile.vue'
import ViewVendorComplianceDetailsModal from '@/components/Home/Modals/ViewVendorComplianceDetails.vue'
import DeleteVendorComplianceDetailsModal from '@/components/Home/Modals/DeleteVendorComplianceDetails.vue'
import DocHubInstructionsModal from '@/components/Home/Modals/DocHubInstructions.vue'
import CompleteFormModal from '@/components/Home/Modals/CompleteFormModal'

export default {
	name: 'compliances',
	components: {
		SideBar,
		ViewComplianceFileModal,
		ViewVendorComplianceDetailsModal,
		DeleteVendorComplianceDetailsModal,
		DocHubInstructionsModal,
		CompleteFormModal
	},
	computed: {
		hasSelection(){
			// A child route (an item, or its not-found page) is open.
			return !!this.$route.params.items;
		},
		...mapState('notify', {
			viewComplianceFilesModal: state => state.viewComplianceFilesModal,
			viewVendorComplianceDetailsModal: state => state.viewVendorComplianceDetailsModal,
			showDeleteVendorComplianceDetailConfirm: state => state.showDeleteVendorComplianceDetailConfirm,
			viewDocHubInstructionModal: state => state.viewDocHubInstructionModal,
			viewCompleteOnlineFormModal: state => state.viewCompleteOnlineFormModal,
		})
	},
	methods: {
		backToItems(){
			this.$router.push('/compliances');
		},
		// On desktop the detail panel must never be blank: if the route is the
		// bare /compliances list (reachable via the mobile back button, then
		// widening the window), open the default item. Mobile keeps the list.
		redirectIfDesktop(){
			if(window.innerWidth > 1024 && !this.$route.params.items){
				this.$router.push({ name: 'items', params: { items: 'welcome' }, query: { id: '1', display_name: 'Welcome' } });
			}
		}
	},
	mounted(){
		window.addEventListener('resize', this.redirectIfDesktop);
		this.redirectIfDesktop();
	},
	beforeUnmount(){
		window.removeEventListener('resize', this.redirectIfDesktop);
	}
}
</script>
<style scoped>
#compliance-main{
	display: flex;
	margin: 50px;
	border: 1px solid #E3E3E3;
	box-shadow: 0px 2px 4px RGB(0 0 0 / 10%);
	-webkit-box-shadow: 0px 2px 4px rgb(0 0 0 / 10%);
	background: #FFF;
	height: calc(100vh - 120px);
}
#side-bar{
	width: 350px;
	height: 100%;
	overflow-y: auto;
	border-right: 1px solid #dddddd;
}

#compliance-view{
	width: 100%;
	height: 100%;
	overflow-y: auto;
}

#back-to-items{
	display: none;
	margin: 10px 15px;
	padding: 10px 20px;
	cursor: pointer;
	font-weight: bold;
	color: #fff;
	background: #5179D6;
	border-radius: 4px;
}

@media screen and (max-width: 1024px){
	body {
		overflow-y: scroll !important;
		position: relative;
	}
	#compliance-main{
		margin: 15px;
		border: none;
		box-shadow: 0;
		-webkit-box-shadow: 0;
		background: #FFF;
		height: 100%;
		overflow-y: auto;
	}

	/* Master-detail: show the list by default, the selected item's details
	   once one is open, with a back button to return to the list. */
	#side-bar{
		border-right: none;
	}
	#compliance-main.has-selection #side-bar{
		display: none;
	}
	#compliance-main:not(.has-selection) #compliance-view{
		display: none;
	}
	#back-to-items{
		display: block;
	}


}

</style>